import React, { useEffect, useState } from "react";
import { TableHeaderProps } from "../../../../../utils/types";
import { TextField } from "@mui/material";
import {
  CustomModal,
  handleMUISelectEvent,
} from "../../../../../utils/UtilFunctions";
import ViewAsset from "../stockentry/ViewAsset";

import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import Input from "../../../../../stories/Input/Input";
import {
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import { totalData } from "./StockBalanceAdd";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import useAssetTableJson from "../../../../../json/useAssetTableJson";

import {
  GridAlignment,
  GridCellParams,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import Eyewhite from "../../../../../images/EyeWhite.svg";
import { Button } from "../../../../../stories/Button/Button";
import ViewStocks from "./ViewStocks";
import ItemDetails from "./ItemDetails";
const options = ["IT Equipment", "Tools and Machinery", "Softwares"];

const Data = [{ location: "Kr Puram", total: 0 }];
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const LocationDetails = ({ setModalFlag }: Props) => {
  const [viewAsset, setViewAsset] = useState(false);
  const { Purchase } = useAssetTableJson();

  const [viewStocks, setViewStocks] = useState(false);

  const dynamicHeaders: TableHeaderProps[] =
    Purchase.stockBalance.LocationDetails.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        if (params.field === "actions") {
          return (
            <button
              className="location-details__tableblock--actions"
              onClick={() => setViewStocks(!viewStocks)}
            >
              View Stocks <img src={Eyewhite} alt="" />
            </button>
          );
        } else return params.value;
      },
    }));
  const columns: GridColDef[] = [...dynamicHeaders];
  const rows1: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        location_name: data.location,
        total: 0,
      };
    }) || [];

  const getRow = () => {
    if (Data.length) {
      return [
        {
          id: [],

          location_name: "Total",
          total: 0,

          actions: [],
        },
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow(),
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "total":
          return "total-count";
        case "location_name":
          return "total";

        default:
          return "hide-td";
      }
    }

    return "";
  };

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.STOCK_BALANCE_LOCATION_DETAILS
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.STOCK_BALANCE_LOCATION_DETAILS,
      JSON.stringify(newModel)
    );
  };
  return (
    <>
      <div className="location-details">
        <div className="location-details__title">
          <Title>Location Details</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <ItemDetails />
        <div className="location-details__filter row g-0">
          <div className="col">
            <Input id="data_search" placeholder="Search..." />
          </div>
          <div className="col">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={options}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Filter Stock Location"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>{" "}
          {totalData.map((data, index) => (
            <div
              className={`col stock-balance-add__row--${
                data.title === "Sub Store" || data.title === "Stock In Hand"
                  ? "sub"
                  : "main"
              }`}
              key={index}
            >
              <img src={data.image} alt="" />
              <span>{data.title}</span>
              <b>{data.count}</b>
            </div>
          ))}
        </div>
        <div className="location-details__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows1}
            rowHeight={TABLE_ROW_HEIGHT}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
            disableRowSelectionOnClick
            hideFooter
            pinnedRows={pinnedRows}
            getCellClassName={getCellClassName}
          />
        </div>
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
      <CustomModal
        isOpen={viewAsset}
        onRequestClose={() => setViewAsset(!viewAsset)}
        contentComponent={<ViewAsset setModalFlag={setViewAsset} itemId={0} />}
        style={ViewModalStyles}
      />
      <CustomModal
        isOpen={viewStocks}
        onRequestClose={() => setViewStocks(!viewStocks)}
        contentComponent={<ViewStocks setModalFlag={setViewStocks} />}
        style={ViewModalStyles}
      />
    </>
  );
};

export default LocationDetails;
